module.exports = __webpack_public_path__ + "static/media/warning-orange.53490a84.svg";